module.exports = __webpack_public_path__ + "media/application/images/icons/quote-5373d58c622294f52bcbd5e03e410ceb.svg";